import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'parentesco',
    standalone: false
})
export class ParentescoPipe implements PipeTransform {

  transform(value: number, ...string: unknown[]): string {
    let tipo = '';
    switch (value.toString().trim()) {
      case '0':
        tipo = 'Titular';
        break;
      case '1':
        tipo = 'Cónyuge';
        break;
      case '2':
        tipo = 'Concubino/a';
        break;
      default:
        tipo = 'Hijo/a';
        break;
    }
    return tipo;
  }

}
